// Age Confirmation Modal //

let ageModal = document.querySelector('.age-modal');
let closeAgeModal = document.getElementById('close-age-modal');
const ageModalSessionItem = 'casamadero-age-modal';

if (ageModal) {
  closeAgeModal.addEventListener('click', function () {
    document.querySelector('body').classList.remove('overflow-y-hidden');
    ageModal.classList.add('opacity-0');
    sessionStorage.setItem(ageModalSessionItem, 'allowed');
    setTimeout(function () {
      ageModal.classList.add('hidden');
    }, 500);
  });

  if (sessionStorage.getItem(ageModalSessionItem)) {
    ageModal.classList.add('hidden');
  } else {
    document.querySelector('body').classList.add('overflow-y-hidden');
    ageModal.classList.remove('opacity-0');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  // gsap global scroll effects //

  let fadeInOnScrolls = document.querySelectorAll('.fade-in-on-scroll');
  if (fadeInOnScrolls.length >= 1) {
    fadeInOnScrolls.forEach(function (element) {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          yPercent: 25,
        },
        {
          yPercent: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'top center',
            scrub: 0.2,
          },
        }
      );
    });
  }

  // header scripts //

  let header = document.querySelector('header');
  let navbar = document.getElementById('navbar');
  const navbarLogo = navbar.querySelector('img.logo');
  let topPosition = window.scrollY;
  function makeNavbarNormal() {
    navbar.classList.remove('lg:!bg-transparent', 'lg:!text-white', 'lg:!fill-white');
    if (navbarLogo) {
      navbarLogo.classList.remove('lg:brightness-0', 'lg:saturate-100', 'lg:invert');
    }
  }
  function makeNavbarTransparent() {
    navbar.classList.add('lg:!bg-transparent', 'lg:!text-white', 'lg:!fill-white');
    if (navbarLogo) {
      navbarLogo.classList.add('lg:brightness-0', 'lg:saturate-100', 'lg:invert');
    }
  }
  if (navbar.classList.contains('index') && topPosition >= 128) {
    makeNavbarNormal();
  }

  if (navbar.classList.contains('index')) {
    window.addEventListener('scroll', function () {
      topPosition = window.scrollY;
      if (topPosition >= 128) {
        makeNavbarNormal();
      } else {
        if (!navbar.classList.contains('active')) {
          makeNavbarTransparent();
        }
      }
    });
  }

  let menuButtons = document.querySelectorAll('.menu-button');
  let menus = document.querySelectorAll('.menu');

  menuButtons.forEach(function (menuButton) {
    let target = menuButton.dataset.target;
    let targetEl = document.querySelector(`.menu#${target}`);
    let tl = gsap.timeline();
    let showMenu = {
      autoAlpha: 1,
      ease: 'linear',
      duration: 0.3,
      onStart: function () {
        menuButton.classList.add('font-bold');
      },
    };
    let hideMenu = {
      autoAlpha: 0,
      ease: 'linear',
      duration: 0.3,
      onStart: function () {
        menuButtons.forEach(function (menuButton) {
          menuButton.classList.remove('font-bold');
        });
      },
    };
    menuButton.addEventListener('mouseenter', function () {
      if (navbar.classList.contains('index') && window.scrollY < 128) {
        navbar.classList.remove('lg:!bg-transparent', 'lg:!fill-white', 'lg:!text-white');
        navbar.classList.add('active');
        if (navbarLogo) {
          navbarLogo.classList.remove('lg:brightness-0', 'lg:saturate-100', 'lg:invert');
        }
      }
      tl.to(menus, {
        ...hideMenu,
      });
      tl.to(
        targetEl,
        {
          ...showMenu,
        },
        '<'
      );
      header.addEventListener('mouseleave', function () {
        if (navbar.classList.contains('index') && window.scrollY < 128) {
          navbar.classList.remove('active');
          navbar.classList.add('lg:!bg-transparent', 'lg:!fill-white', 'lg:!text-white');
          if (navbarLogo) {
            navbarLogo.classList.add('lg:brightness-0', 'lg:saturate-100', 'lg:invert');
          }
        }
        gsap.to(targetEl, {
          ...hideMenu,
        });
      });
    });
  });

  // toggle header

  let lastScrollTop = 0;

  window.onscroll = function () {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop + 5 && currentScroll > 640) {
      gsap.to(header, {
        yPercent: -100,
        duration: 0.4,
      });
      gsap.to('.menu', {
        opacity: 0,
      });
    } else if (currentScroll < lastScrollTop) {
      gsap.to(header, {
        yPercent: 0,
        duration: 0.4,
      });
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  // Start mobile nav //

  let mobileMenu = document.getElementById('mobile-menu');
  let mobileMenuButton = document.getElementById('mobile-menu-button');
  let menuIcon = mobileMenuButton.querySelector('.menu-icon');
  let closeIcon = mobileMenuButton.querySelector('.close-icon');
  mobileMenuButton.addEventListener('click', function () {
    if (mobileMenu.classList.contains('active')) {
      gsap.to(mobileMenu, {
        autoAlpha: 0,
        duration: 0.3,
      });
      mobileMenu.classList.remove('active');
      menuIcon.classList.remove('hidden');
      closeIcon.classList.add('hidden');
    } else {
      gsap.to(mobileMenu, {
        autoAlpha: 1,
        duration: 0.3,
      });
      mobileMenu.classList.add('active');
      menuIcon.classList.add('hidden');
      closeIcon.classList.remove('hidden');
    }
  });

  let menuAccordionButtons = document.querySelectorAll('.menu-accordion-button');
  let menuAccordionContents = document.querySelectorAll('.menu-accordion-content');

  menuAccordionButtons.forEach(function (menuAccordionButton) {
    menuAccordionButton.addEventListener('click', function () {
      let menuAccordionContent = menuAccordionButton.nextElementSibling;
      let svg = menuAccordionButton.querySelector('svg');
      if (menuAccordionContent.classList.contains('grid-rows-[1fr]')) {
        closeMenuAccordionContents();
        svg.classList.remove('rotate-180');
        menuAccordionButton.classList.remove('bg-near-white', 'font-bold');
        menuAccordionContent.classList.remove('bg-near-white');
      } else {
        closeMenuAccordionContents();
        svg.classList.add('rotate-180');
        menuAccordionContent.classList.remove('grid-rows-[0fr]');
        menuAccordionContent.classList.add('grid-rows-[1fr]');
        menuAccordionButton.classList.add('bg-near-white', 'font-bold');
        menuAccordionContent.classList.add('bg-near-white');
      }
    });
  });

  function closeMenuAccordionContents() {
    menuAccordionContents.forEach(function (menuAccordionContent) {
      let menuAccordionButton = menuAccordionContent.previousElementSibling;
      let svg = menuAccordionButton.querySelector('svg');
      svg.classList.remove('rotate-180');
      menuAccordionContent.classList.remove('grid-rows-[1fr]');
      menuAccordionContent.classList.add('grid-rows-[0fr]');
    });
  }
  // End mobile nav //

  // Start Search Menu //
  let searchButton = document.getElementById('search-button');
  let search = document.getElementById('search');
  let closeSearchButton = document.getElementById('close-search-button');

  if (searchButton) {
    searchButton.addEventListener('click', function (event) {
      search.classList.toggle('hidden');
      search.classList.toggle('active');
    });
  }

  if (closeSearchButton) {
    closeSearchButton.addEventListener('click', function () {
      closeSearch();
    });
  }

  function closeSearch() {
    search.classList.add('hidden');
    search.classList.remove('active');
  }
  // End Search Menu //

  // Start Home Swiper //
  let carouselSwiper = new Swiper('.carousel-swiper', {
    freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    slidesPerView: 1.6,
    spaceBetween: 16,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 32,
      },
    },
  });
  // End Home Swiper //

  // Start Cart //
  let cartButton = document.getElementById('cart-button');
  let closeCartButton = document.getElementById('close-cart-button');
  let cart = document.getElementById('cart');
  let cartBackdrop = document.getElementById('cart-backdrop');

  if (cartButton) {
    cartButton.addEventListener('click', function () {
      openCart();
    });
  }

  if (closeCartButton) {
    closeCartButton.addEventListener('click', function () {
      closeCart();
    });
  }

  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', function () {
      closeCart();
    });
  }

  document.onkeydown = function (e) {
    let isEscape = false;
    if ('key' in e) {
      isEscape = e.key === 'Escape' || e.key === 'Esc';
    } else {
      isEscape = e.keyCode === 27;
    }
    if (isEscape) {
      closeCart();
    }
  };

  function closeCart() {
    cart.classList.add('-right-[36rem]');
    cart.classList.remove('right-0');
    document.body.classList.remove('overflow-y-hidden');
    cartBackdrop.classList.add('opacity-0', 'pointer-events-none');
  }

  function openCart() {
    cart.classList.remove('-right-[36rem]');
    cart.classList.add('right-0');
    document.body.classList.add('overflow-y-hidden');
    cartBackdrop.classList.remove('opacity-0', 'pointer-events-none');
  }
  // End Cart //

  // Start Accordion //
  let accordions = document.querySelectorAll('.accordion');
  /* let accordionHeader = document.querySelectorAll('.accordion-header');
  let accordionContents = document.querySelectorAll('.accordion-content');
  let accordionChevrons = document.querySelectorAll('.accordion-chevron');

  accordionHeader.forEach(function (accordionHeader) {
    if (accordionHeader.classList.contains('active')) {
      let chevron = accordionHeader.querySelector('.accordion-chevron');
      let content = accordionHeader.nextElementSibling;
      content.classList.remove('hidden');
      chevron.classList.add('rotate-180');
    }
    accordionHeader.addEventListener('click', function () {
      let chevron = accordionHeader.querySelector('.accordion-chevron');
      if (accordionHeader.classList.contains('active')) {
        closeAccordions();
        return;
      }
      closeAccordions();
      let content = accordionHeader.nextElementSibling;
      content.classList.toggle('hidden');
      chevron.classList.add('rotate-180');
      accordionHeader.classList.add('active');
    });
  });

  function closeAccordions() {
    accordionContents.forEach(function (contents) {
      contents.classList.add('hidden');
      contents.previousElementSibling.classList.remove('active');
    });
    accordionChevrons.forEach(function (chevron) {
      chevron.classList.remove('rotate-180');
    });
  } */

  // accordion events synced with product tabs script
  accordions.forEach(function (accordion) {
    const accordionHeader = accordion.querySelector('.accordion-header');
    const accordionContent = accordion.querySelector('.accordion-content');
    const accordionChevron = accordion.querySelector('.accordion-chevron');

    if (accordion.classList.contains('active')) {
      accordionContent.classList.remove('hidden');
      accordionChevron.classList.add('rotate-180');
    }

    accordionHeader.addEventListener('click', function () {
      const isActive = accordion.classList.contains('active');
      const activeTab = accordion.parentElement.querySelector('.active');
      if (activeTab) {
        const activeContent = activeTab.querySelector('.accordion-content');
        const activeChevron = activeTab.querySelector('.accordion-chevron');

        activeContent.classList.add('hidden');
        activeChevron.classList.remove('rotate-180');
        activeTab.classList.remove('active');
        if (isActive) return;
      }
      accordionContent.classList.remove('hidden');
      accordionChevron.classList.add('rotate-180');
      accordion.classList.add('active');
    });
  });
  // End Accordion //

  let singleSwiper = new Swiper('.single-swiper', {
    slidesPerView: 1,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  });

  let imageSwiper = new Swiper('.image-swiper', {
    slidesPerView: 1,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  });

  // wine tabs home //

  let tabGroups = document.querySelectorAll('.tab-group');
  tabGroups.forEach(function (tabGroup) {
    let tabButtons = tabGroup.querySelectorAll('.tab-button');
    let tabs = tabGroup.querySelectorAll('.tab');
    tabButtons.forEach(function (tabButton) {
      let target = tabButton.dataset.target;
      let targetEl = tabGroup.querySelector(`#${target}-tab`);
      tabButton.addEventListener('click', function () {
        tabButtons.forEach(function (tabButton) {
          tabButton.classList.remove('active');
        });
        tabButton.classList.add('active');
        tabs.forEach(function (tab) {
          tab.classList.add('invisible', 'h-0');
        });
        targetEl.classList.remove('invisible', 'h-0');
      });
    });
  });

  // modals //

  let modalButtons = document.querySelectorAll('.open-modal');
  let modals = document.querySelectorAll('.modal');

  modalButtons.forEach(function (modalButton) {
    modals.forEach(function (modal) {
      let backdrop = modal.querySelector('.modal-backdrop');
      backdrop.addEventListener('click', function () {
        gsap.to(modal, {
          autoAlpha: 0,
        });
      });
      modalButton.addEventListener('click', function () {
        gsap.to(modal, {
          autoAlpha: 1,
        });
      });
    });
  });

  // dynamic modals

  const modalTriggers = document.querySelectorAll('[data-modal_trigger]');
  modalTriggers.forEach((trigger) => {
    const modal = document.querySelector(`[data-modal="${trigger.dataset.modal_trigger}"]`);
    if (!modal) {
      return;
    }
    const backdrop = modal.querySelector('.modal-backdrop');
    backdrop.addEventListener('click', function () {
      document.body.classList.remove('overflow-hidden');
      gsap.to(modal, {
        autoAlpha: 0,
      });
    });
    const close = modal.querySelector('.modal-close');
    if (close) {
      close.addEventListener('click', function () {
        document.body.classList.remove('overflow-hidden');
        gsap.to(modal, {
          autoAlpha: 0,
        });
      });
    }
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      document.body.classList.add('overflow-hidden');
      gsap.to(modal, {
        autoAlpha: 1,
      });
    });
  });

  // timeline swiper //
  let timelineSwiper = new Swiper('.timeline-swiper', {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 16,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      640: {
        spaceBetween: 24,
      },
      1024: {
        spaceBetween: 32,
      },
    },
  });

  // Start Multicolumn Swiper //
  let multicolumnSwiper = new Swiper('.multicolumn-swiper', {
    freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    slidesPerView: 1,
    spaceBetween: 24,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
    },
  });
  // End Multicolumn Swiper //

  // product page -> awards swiper //
  let awardsSwiper = new Swiper('.awards-swiper', {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 12,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  });
});
